import { render, staticRenderFns } from "./PageImg01.vue?vue&type=template&id=2e00bc78&scoped=true&"
import script from "./PageImg01.vue?vue&type=script&lang=js&"
export * from "./PageImg01.vue?vue&type=script&lang=js&"
import style0 from "./PageImg01.vue?vue&type=style&index=0&id=2e00bc78&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e00bc78",
  null
  
)

export default component.exports